<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<div
  class="ngx-charts-outer"
  [style.width.px]="view[0]"
  [@animationState]="'active'"
  [@.disabled]="!animations">
  <svg
    class="ngx-charts"
    [attr.width]="chartWidth"
    [attr.height]="view[1]">
    <ng-content></ng-content>
  </svg>
  @if (showLegend && legendType === 'scaleLegend') {
    <ngx-charts-scale-legend
      class="chart-legend"
      [horizontal]="legendOptions && legendOptions.position === 'below'"
      [valueRange]="legendOptions.domain"
      [colors]="legendOptions.colors"
      [height]="view[1]"
      [width]="legendWidth">
    </ngx-charts-scale-legend>
  }
  @if (showLegend && legendType === 'legend') {
    <ngx-charts-legend
      class="chart-legend"
      [horizontal]="legendOptions && legendOptions.position === 'below'"
      [data]="legendOptions.domain"
      [title]="legendOptions.title"
      [colors]="legendOptions.colors"
      [height]="view[1]"
      [width]="legendWidth"
      [activeEntries]="activeEntries"
      (labelClick)="legendLabelClick.emit($event)"
      (labelActivate)="legendLabelActivate.emit($event)"
      (labelDeactivate)="legendLabelDeactivate.emit($event)">
    </ngx-charts-legend>
  }
</div>
